import { createSlice } from "@reduxjs/toolkit";


const contentRequestCreateSlice = createSlice({
  name: "contentRequestCreate",
  initialState:{
    subjects:[],
    selectedSubjects:[],
    owners:[],
    selectedQuestionCodes: [],
    userRoleMap:{}
  },
  reducers: {
    fetchSubjects: (state,action)=>{
      return {...state,subjects:action.payload.subjects}
    },
    addSubjects:(state,action)=>{
          return {...state,selectedSubjects:action.payload};
    },
    fetchOwners:(state,action)=>{
      return {...state,owners:action.payload.owners}
       //  return {...state,selectedSubjects:action.payload};
    },
    setSelectedQuestionCodes: (state, action)=> {
      state.selectedQuestionCodes = action.payload
    },
    setUserRoleMap:(state,action)=>{
      const userRoleMap=action.payload;
    return {...state,userRoleMap};
    },
  }
});

const { actions, reducer } = contentRequestCreateSlice;

export default reducer;
export const contentRequestCreateActions = actions;
